import { axiosWithToken } from '../../../utils/axios';

export type UrlsByBandType = {
  [K in number]: string;
};

export type UrlsByTimeType = {
  [K in string]: string
}

type GetGeeUrlParams = {
  imageId: string;
  timeList?: number[];
};

type GEEUrlResponseType = {
  map_url: UrlsByBandType | null;
};

const geeUrlRequestCache = new Map<string, Promise<GEEUrlResponseType | null>>();

export async function getGeeUrl({ imageId, timeList = [] }: GetGeeUrlParams): Promise<GEEUrlResponseType | null> {
  const data = { imageId, timeList };
  const cacheKey = JSON.stringify(data);
  const cachedRequest = geeUrlRequestCache.get(cacheKey);
  if (cachedRequest) {
    return cachedRequest;
  }

  const request = axiosWithToken
    .post(`/map/`, { data, isToken: true })
    .then(res => res.data as GEEUrlResponseType)
    .catch(error => {
      console.error('Failed to get GEE URL', error);
      return null;
    })
    .finally(() => {
      geeUrlRequestCache.delete(cacheKey);
    });

  geeUrlRequestCache.set(cacheKey, request);
  return request;
}
